import { globalApiService } from '../globalApiSlice';
import type { StoreBaseResponse } from '@/types/types';
import type { RequestOptions } from '@/services/apiService';
import { createCustomError, createCustomResponse } from '@/helpers/utils';
import { AlarmsService } from '@/services/masters/user/alarmService';
import type { MyAlarm } from '@/types/user/alarm-types';

const service = new AlarmsService();

const alarmsApi = globalApiService.injectEndpoints({
  endpoints: (build) => ({
    getMyAlarms: build.mutation<
      StoreBaseResponse<MyAlarm[]>,
      RequestOptions['params']
    >({
      queryFn: async (body) => {
        try {
          const response = await service.getMyAlarms(body);
          return createCustomResponse(response);
        } catch (error) {
          return createCustomError(error);
        }
      },
    }),
  }),
});

export const { useGetMyAlarmsMutation } = alarmsApi;
